/* eslint-disable max-lines */
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import {
  AddAddressContent,
  AddAddressErrorMessages,
  AddAddressFormAttributes,
  AddAddressPageContent
} from '../models/add-address.interface';

const countryListMock: UlItem[] = [
  {
    value: 'US',
    label: 'United States'
  },
  {
    value: 'IND',
    label: 'India'
  },
  {
    value: 'UK',
    label: 'United Kingdom'
  }
];

const stateListMock: UlItem[] = [
  {
    value: 'MH',
    label: 'Maharastra'
  },
  {
    value: 'TS',
    label: 'Telangana'
  },
  {
    value: 'TN',
    label: 'Tamil Nadu'
  }
];

const formAttributesMock: AddAddressFormAttributes = {
  errorCount: 0,
  submitAttempt: false,
  errorAlertBanner: false,
  addressLine1ControlTouched: false,
  addressLine2ControlTouched: false,
  districtControlTouched: false,
  stateControlTouched: false,
  countryControlTouched: false,
  addressLine6ControlTouched: false,
  cityControlTouched: false,
  postalCodeControlTouched: false,
  disableActionButton: false
};

const pageContentMock: AddAddressPageContent = {
  addressLine1Label: 'Address Line 1',
  addressLine2Label: 'Address Line 2',
  cityLabel: 'City*',
  stateLabel: 'State/Province',
  countryLabel: 'Country',
  buttonLabel: 'Continue',
  contentBodyHeader:
    'We do not have security questions associated with your account. You must establish security questions and answer to continue.',
  defaultCountrySelectValue: 'US',
  defaultStateSelectValue: 'Select',
  errors: {
    alertWarning: '',
    addressLine1ErrorMessage: {
      INVALID_ADDR_LINE_1: '',
      ADDR_WITH_NO_LETTERS: ''
    },
    addressLine2ErrorMessage: {
      INVALID_ADDR_LINE_2: ''
    },
    districtErrorMessage: {
      INVALID_DISTRICT: ''
    },
    cityErrorMessage: {
      INVALID_CITY: ''
    },
    stateErrorMessage: {
      SELECT_STATE: '',
      SELECT_PREFECTURE: ''
    },
    postalCodeErrorMessage: {
      INVALID_ZIP_CODE: ''
    }
  },
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_loginHelp: '',
    button_modal: 'Continue',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'setPassword',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: '',
    overlayMessage: '',
    refreshUrl: ''
  },
  pageHeader: {
    headerSubTitle: '*fields required',
    headerTitle: 'Address Confirmation',
    altText: 'logo',
    logoUrl:
      'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png'
  },
  postalCodeLabel: 'Postal Code*',
  viewName: 'addAddress',
  countryList: countryListMock,
  stateList: stateListMock,
  addressFields: {
    addressLine1: { visible: true, label: 'Address Line 1', required: true },
    addressLine2: { visible: true, label: 'Address Line 2', required: true },
    addressLine3: { visible: true, label: 'Address Line 3', required: true },
    addressLine4: { visible: true, label: 'Address Line 4', required: true },
    addressLine5: { visible: true, label: 'Address Line 5', required: true },
    addressLine6: { visible: true, label: 'Address Line 6', required: true },
    addressLine7: { visible: true, label: 'Address Line 7', required: true },
    addressLine9: { visible: true, label: 'Address Line 9', required: true }
  }
};

export const addaddressFormGroupMock: UntypedFormGroup = new UntypedFormGroup({
  addressLine1: new UntypedFormControl(null, [Validators.required]),
  addressLine2: new UntypedFormControl(null, [Validators.required]),
  city: new UntypedFormControl(null, [Validators.required]),
  country: new UntypedFormControl(null, [Validators.required]),
  addressLine6: new UntypedFormControl(null, [Validators.required]),
  state: new UntypedFormControl(null, [Validators.required]),
  district: new UntypedFormControl(null),
  postalCode: new UntypedFormControl(null, [Validators.required])
});

const addAddressContentMock: AddAddressContent = {
  formGroup: addaddressFormGroupMock,
  formAttributes: formAttributesMock,
  pageContent: pageContentMock,
  hasError: false,
  errorMessage: ''
};

export const mockAddAddressErrorMessages: AddAddressErrorMessages = {
  addressLine1ErrorMessage: {
    INVALID_ADDR_LINE_1: '',
    ADDR_WITH_NO_LETTERS: ''
  },
  addressLine2ErrorMessage: {
    INVALID_ADDR_LINE_2: ''
  },
  districtErrorMessage: {
    INVALID_DISTRICT: ''
  },
  cityErrorMessage: {
    INVALID_CITY: ''
  },
  stateErrorMessage: {
    SELECT_STATE: '',
    SELECT_PREFECTURE: ''
  },
  postalCodeErrorMessage: {
    INVALID_ZIP_CODE: ''
  },
  alertWarning: ''
};

export default addAddressContentMock;
